import type { IconProps } from "./icon-types";

/**
 * 일반 화면(screen normal / restore). 전체화면 해제 버튼 등에서 [[ScreenFullIcon]]과 세트로 사용.
 *
 * 세트인 [[ScreenFullIcon]](Lucide `maximize`)에 맞춰 안쪽을 향한 네 모서리 브라켓만 있는
 * `react-icons/lu`의 `LuMinimize`(Lucide `minimize`)로 인라인 재현 —
 * c6 패키지는 외부 아이콘 라이브러리를 import하지 않으므로(RFC-design-system-split §아이콘).
 * 다른 c6 아이콘과 톤·크기를 맞추기 위해 24 그리드 / stroke 기반 사용.
 */
export const ScreenNormalIcon = (props: IconProps) => (
  <svg
    width="1em"
    height="1em"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
    aria-hidden="true"
    {...props}
  >
    <path d="M8 3v3a2 2 0 0 1-2 2H3" />
    <path d="M21 8h-3a2 2 0 0 1-2-2V3" />
    <path d="M3 16h3a2 2 0 0 1 2 2v3" />
    <path d="M16 21v-3a2 2 0 0 1 2-2h3" />
  </svg>
);
